import {
  FontAwesomeIcon,
  IconProp,
  faenvelopeclassicregular,
  faphoneclassicregular
} from '@grc/ui-package';
import { AddressFormatter, MaskPhoneNumberWithCountryCode } from '@grc/ui-shared';
import { IShipmentLocation } from '../../../../../../models/shipments/shipment-details.interface';
import './location-card.scss';

interface ILocationCardProps {
  title: string;
  data?: IShipmentLocation;
}

// Read-only port of the reference Order app's LocationDetails component -
// only the `displayDetailsMode` (view) branch: name, address, phone/email,
// primary contact. No "Change" link, no AddContactPopup, no entity search -
// those are edit-only affordances this read-only screen doesn't need.
export default function LocationCard({ title, data }: ILocationCardProps) {
  const primaryContact = data?.contacts?.find(contact => contact.isPrimary);

  return (
    <div className="location-card">
      <div className="location-card-title grc-value">{title}</div>

      {!data ? (
        <div className="grc-text-light">-</div>
      ) : (
        <>
          <div className="location-card-name header-name">{data.name}</div>

          {data.address && (
            <div className="location-card-address">
              <AddressFormatter address={data.address} />
            </div>
          )}

          <div className="location-card-contact-line d-flex">
            {data.generalPhoneNumber?.phoneNumber && (
              <span className="mr-4">
                <FontAwesomeIcon icon={faphoneclassicregular as IconProp} />
                <span className="ml-2">
                  {MaskPhoneNumberWithCountryCode(
                    data.generalPhoneNumber.phoneNumber,
                    data.generalPhoneNumber.phoneType
                  )}
                </span>
              </span>
            )}
            {data.generalEmailAddress && (
              <span>
                <FontAwesomeIcon icon={faenvelopeclassicregular as IconProp} />
                <span className="ml-2">{data.generalEmailAddress}</span>
              </span>
            )}
          </div>

          {primaryContact && (
            <div className="location-card-primary-contact">
              <hr />
              <div className="header-name">{primaryContact.wholeName}</div>
              <div className="d-flex">
                {primaryContact.phoneNumber?.[0]?.phoneNumber && (
                  <span className="mr-4">
                    <FontAwesomeIcon icon={faphoneclassicregular as IconProp} />
                    <span className="ml-2">
                      {MaskPhoneNumberWithCountryCode(
                        primaryContact.phoneNumber[0].phoneNumber,
                        primaryContact.phoneNumber[0].phoneType
                      )}
                    </span>
                  </span>
                )}
                {primaryContact.email && (
                  <span>
                    <FontAwesomeIcon icon={faenvelopeclassicregular as IconProp} />
                    <span className="ml-2">{primaryContact.email}</span>
                  </span>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
